import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon, Link, Modal } from '@phishtool/ui';
import { StyledDownloadList, StyledDownloadListItem, StyledQuoteButton } from './styled';
import { contentService } from '~service';
const complianceDocuments = [
    {
        label: 'Data Processing Addendum (DPA) Cover Note.pdf',
        id: 'data-processing-addendum-cover-note',
    },
    {
        label: 'Data Processing Agreement.pdf',
        id: 'data-processing-agreement',
    },
    {
        label: 'Privacy Policy.pdf',
        id: 'privacy-policy',
    },
    {
        label: 'Proof of Value Agreement.pdf',
        id: 'proof-of-value-agreement',
    },
    {
        label: 'Security and Compliance Overview.pdf',
        id: 'security-and-compliance-overview',
    },
    {
        label: 'Service Agreement.pdf',
        id: 'service-agreement',
    },
    {
        label: 'Terms of Service.pdf',
        id: 'terms-of-service',
    },
];
const ComplianceDocuments = () => {
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => setIsOpen(false);
    return (_jsxs(_Fragment, { children: [_jsxs(StyledQuoteButton, { href: "#", onClick: (e) => {
                    e.preventDefault();
                    setIsOpen(true);
                }, children: [_jsx("span", { children: "Compliance documents" }), _jsx(Icon, { name: "document", size: { width: 52, height: 36 }, alignment: "vertical" })] }), _jsx(Modal, { isOpen: isOpen, closeModal: closeModal, heading: "Compliance documents", headingSize: "large", size: "small", children: _jsx(StyledDownloadList, { children: complianceDocuments.map((complianceDocument) => (_jsx(StyledDownloadListItem, { children: _jsx(Link, { color: "burntOrange", to: contentService.getComplianceDocumentUrl({ contentId: complianceDocument.id }), download: complianceDocument.label, downloadIcon: true, children: complianceDocument.label }) }, complianceDocument.id))) }) })] }));
};
export default ComplianceDocuments;
